import { MutationTree } from 'vuex';
import { IAdministrationState } from './state';
import {
    ArtikelApiDto,
    BenutzerDetailApiDto,
    BenutzerInfoSearchResultApiDto,
    LieferantDetailApiDto,
    LieferantDokumentApiDto,
    TakeTeilnehmerApiDto,
    TeilnehmerListApiDto,
    TvsLieferantFehlerhafteRechnungApiDto,
    VetdataVerarbeitungLogApiDto
} from '@/api-schema';
import { ArtikelFilterDto } from '@/types/ArtikelFilterDto';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { LieferantenDokumentFilterDto } from '@/types/LieferantenDokumentFilterDto';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';

export const MAPTakeTeilnehmerDATA = 'mapTakeTeilnehmerApiDtoData';
export const ADD_TEILNEHMERLIST = 'addTeilnehmerList';
export const MAP_TEILNEHMERLIST = 'mapTeilnehmerList';
export const CLEAR_ARTIKELFILTER = 'clearArtikelFilter';
export const APPLY_ARTIKELFILTER = 'mapArtikelFilter';
export const CLEAR_TEILNEHMERFILTER = 'clearTeilnehmerFilter';
export const APPLY_TEILNEHMERFILTER = 'mapTeilnehmerFilter';
export const CLEAR_BENUTZERFILTER = 'clearBenutzerFilter';
export const APPLY_BENUTZERFILTER = 'mapBenutzerFilter';
export const LOADING_BENUTZER = 'mapBenutzerLoading';
export const MAPBENUTZERDATA = 'mapBenutzerData';
export const LOADING_TEILNEHMER = 'mapTeilnehmerLoading';
export const LOADING_ARTIKEL = 'mapArtikelLoading';
export const OFFSET_ARTIKEL = 'mapArtikelOffset';
export const OFFSET_TEILNEHMER = 'mapTeilnehmerOffset';
export const TOTAL_NUMBER_OF_RECORDS_TEILNEHMER = 'totalNumberOfRecordsTeilnehmer';
export const TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE = 'totalNumberOfRecordsLieferantenDokumente';
export const TOTAL_NUMBER_OF_RECORDS_ARTIKEL = 'totalNumberOfRecordsArtikel';
export const MAPARTIKEL = 'mapArtikelList';
export const ADDARTIKEL = 'addArtikelToList';
export const MAP_VETDATA_LOG = 'mapVetdataLog';
export const MAP_LIEFERANT_DETAILS_DATA = 'mapLieferantDetailsData';
export const CLEAR_LIEFERANTENDOKUMENT_FILTER = 'clearLieferantenDokumentFilter';
export const APPLY_LIEFERANTENDOKUMENT_FILTER = 'mapLieferantenDokumentFilter';
export const MAP_LIEFERANTEN_DOKUMENTE = 'mapLieferantenDokumente';
export const ADD_LIEFERANTEN_DOKUMENTE = 'addLieferantenDokumente';
export const OFFSET_DOKUMENTE = 'mapDokumenteOffset';
export const LOADING_DOKUMENTE = 'mapDokumenteLoading';
export const MAPBENUTZERDETAILS = 'mapBenutzerDetails';
export const MAP_FEHLERHAFTE_RECHNUNGEN_ADMIN = 'mapFehlerhafteRechnungenAdmin';
export const ADD_FEHLERHAFTE_RECHNUNGEN_ADMIN = 'addFehlerhafteRechnungenAdmin';
export const LOADING_FEHLERHAFTE_RECHNUNGEN_ADMIN = 'mapFehlerhafteRechnungenLoadingAdmin';
export const OFFSET_FEHLERHAFTE_RECHNUNGEN_ADMIN = 'mapFehlerhafteRechnungenOffsetAdmin';
export const TOTAL_NUMBER_OF_RECORDS_FEHLERHAFTE_RECHNUNGEN_ADMIN = 'totalNumberOfRecordsFehlerhafteRechnungenAdmin';
export const APPLY_FEHLERHAFTE_RECHNUNGEN_FILTER_ADMIN = 'mapFehlerhafteRechnungenFilterAdmin';
export const CLEAR_FEHLERHAFTE_RECHNUNGEN_FILTER_ADMIN = 'clearFehlerhafteRechnungenFilterAdmin';
export const SET_LIEFERANTEN = 'setLieferanten';
export const MAP_LIEFERANTEN_FOR_FILTER = 'mapLieferantenForFilter';

export const mutations: MutationTree<IAdministrationState> = {
    [MAPTakeTeilnehmerDATA](state, value: TakeTeilnehmerApiDto) {
        state.teilnehmer = value;
    },
    [ADD_TEILNEHMERLIST](state, value: Array<TeilnehmerListApiDto>) {
        state.teilnehmerList = state.teilnehmerList.concat(value);
    },
    [MAP_TEILNEHMERLIST](state, value: Array<TeilnehmerListApiDto>) {
        state.teilnehmerList = value;
    },
    [CLEAR_ARTIKELFILTER](state) {
        state.artikelQueryFilter = new ArtikelFilterDto();
    },
    [APPLY_ARTIKELFILTER](state, value: ArtikelFilterDto) {
        state.artikelQueryFilter.searchQuery = value.searchQuery;
        state.artikelQueryFilter.sortBy = value.sortBy;
        state.artikelQueryFilter.sortOrder = value.sortOrder;
        state.artikelQueryFilter.offset = 0;
    },
    [CLEAR_TEILNEHMERFILTER](state) {
        state.teilnehmerFilter = new TeilnehmerFilterDto();
    },
    [APPLY_TEILNEHMERFILTER](state, value: TeilnehmerFilterDto) {
        state.teilnehmerFilter.status = value.status;
        state.teilnehmerFilter.suchText = value.suchText;
        state.teilnehmerFilter.teilnehmerTyp = value.teilnehmerTyp;
        state.teilnehmerFilter.hatRechnungenNurViaVetdata = value.hatRechnungenNurViaVetdata;
        state.teilnehmerFilter.hatTvsDokumenteNurDigital = value.hatTvsDokumenteNurDigital;
        state.teilnehmerFilter.suchText = value.suchText;
        state.teilnehmerFilter.sortBy = value.sortBy;
        state.teilnehmerFilter.sortOrder = value.sortOrder;
        state.teilnehmerFilter.offset = 0;
    },
    [CLEAR_BENUTZERFILTER](state) {
        state.benutzerFilter = new BenutzerInfoSearchApiDto();
        state.benutzerInfoSearchResultApiDtoList = null;
    },
    [APPLY_BENUTZERFILTER](state, value: BenutzerInfoSearchApiDto) {
        state.benutzerFilter = value;
    },
    [OFFSET_TEILNEHMER](state, value: number) {
        state.teilnehmerFilter.offset = value;
    },
    [LOADING_BENUTZER](state, value: boolean) {
        state.benutzerLoading = value;
    },
    [MAPBENUTZERDATA](state, benutzerInfoSearchResultApiDtoList: Array<BenutzerInfoSearchResultApiDto>) {
        state.benutzerInfoSearchResultApiDtoList = benutzerInfoSearchResultApiDtoList;
    },
    [LOADING_TEILNEHMER](state, value: boolean) {
        state.teilnehmerLoading = value;
    },
    [LOADING_ARTIKEL](state, value: boolean) {
        state.artikelLoading = value;
    },
    [OFFSET_ARTIKEL](state, value: number) {
        state.artikelQueryFilter.offset = value;
    },
    [TOTAL_NUMBER_OF_RECORDS_TEILNEHMER](state, value: number) {
        state.teilnehmerTotalNumberOfRecords = value;
    },
    [TOTAL_NUMBER_OF_RECORDS_ARTIKEL](state, value: number) {
        state.artikelTotalNumberOfRecords = value;
    },
    [MAPARTIKEL](state, value: Array<ArtikelApiDto>) {
        state.artikelList = value;
    },
    [ADDARTIKEL](state, value: Array<ArtikelApiDto>) {
        state.artikelList = state.artikelList.concat(value);
    },
    [MAP_VETDATA_LOG](state, value: VetdataVerarbeitungLogApiDto) {
        state.vetdataLog = value;
    },
    [MAP_LIEFERANT_DETAILS_DATA](state, value: LieferantDetailApiDto) {
        state.lieferantDetails = value;
    },
    [CLEAR_LIEFERANTENDOKUMENT_FILTER](state) {
        state.lieferantenDokumentFilter = new LieferantenDokumentFilterDto();
    },
    [TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE](state, value: number) {
        state.lieferantenDokumenteTotalNumberOfRecords = value;
    },
    [MAP_LIEFERANTEN_DOKUMENTE](state, value: Array<LieferantDokumentApiDto>) {
        state.lieferantenDokumentList = value;
    },
    [ADD_LIEFERANTEN_DOKUMENTE](state, value: Array<LieferantDokumentApiDto>) {
        state.lieferantenDokumentList = state.lieferantenDokumentList.concat(value);
    },
    [OFFSET_DOKUMENTE](state, value: number) {
        state.lieferantenDokumentFilter.offset = value;
    },
    [LOADING_DOKUMENTE](state, value: boolean) {
        state.dokumenteLoading = value;
    },
    [APPLY_LIEFERANTENDOKUMENT_FILTER](state, value: LieferantenDokumentFilterDto) {
        state.lieferantenDokumentFilter = value;
        state.lieferantenDokumentFilter.offset = 0;
    },
    [MAPBENUTZERDETAILS](state, value: BenutzerDetailApiDto) {
        state.benutzerDetails = value;
    },
    [MAP_FEHLERHAFTE_RECHNUNGEN_ADMIN](state, value: Array<TvsLieferantFehlerhafteRechnungApiDto>) {
        state.fehlerhafteRechnungenList = value;
    },
    [ADD_FEHLERHAFTE_RECHNUNGEN_ADMIN](state, value: Array<TvsLieferantFehlerhafteRechnungApiDto>) {
        state.fehlerhafteRechnungenList = state.fehlerhafteRechnungenList.concat(value);
    },
    [LOADING_FEHLERHAFTE_RECHNUNGEN_ADMIN](state, value: boolean) {
        state.fehlerhafteRechnungenLoading = value;
    },
    [OFFSET_FEHLERHAFTE_RECHNUNGEN_ADMIN](state, value: number) {
        state.fehlerhafteRechnungenFilter.offset = value;
    },
    [TOTAL_NUMBER_OF_RECORDS_FEHLERHAFTE_RECHNUNGEN_ADMIN](state, value: number) {
        state.fehlerhafteRechnungenTotalNumberOfRecords = value;
    },
    [APPLY_FEHLERHAFTE_RECHNUNGEN_FILTER_ADMIN](state, value: RechnungFilterDto) {
        state.fehlerhafteRechnungenFilter = value;
        state.fehlerhafteRechnungenFilter.offset = 0;
    },
    [CLEAR_FEHLERHAFTE_RECHNUNGEN_FILTER_ADMIN](state) {
        state.fehlerhafteRechnungenFilter = new RechnungFilterDto();
    },
    [SET_LIEFERANTEN](state, payload: Array<{ lieferantId: string; lieferantName: string }>) {
        state.lieferantenListe = payload;
    },
    [MAP_LIEFERANTEN_FOR_FILTER](state, values: Array<LieferantDetailApiDto>) {
        const result: Array<object> = [];
        values.forEach((val) => {
            // console.log('mapping values:' + val.firma, +' ' + val.tvsLieferantId);
            result.push({ title: val.firma, value: val.teilnehmerId });
        });
        state.lieferantenListe = result;
    }
};
